// extracted by mini-css-extract-plugin
module.exports = {"Item":"Item_Item__3U1AW","CheckboxMobile":"Item_CheckboxMobile__2EEiT","CheckboxDesktop":"Item_CheckboxDesktop__JFrpJ"};